import {Attachment} from '@hconnect/common/types'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient, useMutation, UseMutationResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {addAttachmentsToQuestion} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'

interface UploadFilesArgs {
  plantId: string
  questionId: string
  files: File[]
}

export const useAddQuestionAttachments = (): UseMutationResult<
  Attachment[],
  unknown,
  UploadFilesArgs
> => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const client = useQueryClient()

  return useMutation({
    mutationFn: (args: UploadFilesArgs) => {
      return addAttachmentsToQuestion(args)
    },
    onSuccess: (data) => {
      void client.invalidateQueries()
      spawnSuccessToast(t('attachments.uploaded.success', {count: data.length}))
    },
    onError: () => {
      spawnErrorToast(t('attachments.uploaded.error'))
    }
  })
}
